export default {"src":"/_next/static/media/expand-less.bc20debe.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};